module.exports = __webpack_public_path__ + "static/icon-ee6020d37526de8884c26e908a23e457.png";